// Deelnemersexport van Sportdata (competitor entries) naar het formaat van
// public.deelnemers_importeren. Zuiver: geen DOM, geen database, te toetsen
// in tests/import-deelnemers.mjs.
//
// Wat hier niet uit komt, bereikt de database nooit: paspoortnummer, adres en
// foto-link. Dat staat vast in WEGGELATEN; de database heeft er ook geen
// kolom voor. E-mail en de nationale en internationale sporter-ID's komen
// wel mee (besluit 5 oktober 2026).
import { leesCsv } from './import-leden.js';

export const VERPLICHT = ['Athlete ID', 'Last Name', 'Category', 'Club ID'];
export const WEGGELATEN = ['Passport-ID', 'Address', 'Photo-Link'];

// Onderdeel uit de naam van de categorie, bijvoorbeeld
// "05280R PATTERN SENIOR 18+ YEARS M/F D04-D06" wordt tul.
export function onderdeelVan(categorie) {
  const c = String(categorie || '').toUpperCase();
  if (/\bPATTERN|\bTUL\b/.test(c)) return 'tul';
  if (/\bSPARRING/.test(c)) return 'sparring';
  if (/\bPOWER|BREAK/.test(c)) return 'breektest';
  if (/\bSPECIAL/.test(c)) return 'speciale_techniek';
  return 'overig';
}

export function geslachtVan(w) {
  const g = String(w || '').trim().toLowerCase();
  if (g === 'm') return 'm';
  if (g === 'f' || g === 'w' || g === 'v') return 'v';
  return g ? 'x' : null;
}

const getal = w => {
  const n = Number(String(w ?? '').replace(',', '.').trim());
  return Number.isFinite(n) && n > 0 ? n : null;
};
const datum = w => (/^\d{4}-\d{2}-\d{2}$/.test(String(w || '').trim()) ? String(w).trim() : null);
const email = w => {
  const e = String(w || '').trim().toLowerCase();
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e) && e.length <= 254 ? e : null;
};
const tijd = w => (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(String(w || '').trim()) ? String(w).trim() : null);

// Geeft { rijen, fouten, genegeerd, weggelaten, kopOntbreekt }.
//   fouten:     [{ rij, fout }] met het regelnummer in het bestand
//   genegeerd:  aantal regels die geen deelnemer zijn (coach, official)
//   weggelaten: per kolom uit WEGGELATEN hoeveel regels een waarde hadden
export function leesDeelnemers(tekst) {
  const regels = leesCsv(tekst);
  const kopIndex = regels.findIndex(r => r.map(c => c.trim()).includes('Athlete ID'));
  if (kopIndex < 0) return { rijen: [], fouten: [], genegeerd: 0, weggelaten: {}, kopOntbreekt: true };
  const kop = regels[kopIndex].map(c => c.trim());
  const ontbreekt = VERPLICHT.filter(k => !kop.includes(k));
  if (ontbreekt.length) return { rijen: [], fouten: [], genegeerd: 0, weggelaten: {}, kopOntbreekt: true, ontbreekt };

  const rijen = [];
  const fouten = [];
  const weggelaten = {};
  const gezien = new Set();
  let genegeerd = 0;
  regels.slice(kopIndex + 1).forEach((cellen, i) => {
    const regel = kopIndex + i + 2;
    const o = Object.fromEntries(kop.map((k, j) => [k, (cellen[j] ?? '').trim()]));
    for (const k of WEGGELATEN) if (o[k] && o[k] !== '0') weggelaten[k] = (weggelaten[k] || 0) + 1;
    const functie = (o.Function || '').toLowerCase();
    if (functie && functie !== 'competitor') { genegeerd++; return; }
    if (!o['Athlete ID'] || !o['Last Name'] || !o.Category) { fouten.push({ rij: regel, fout: 'onvolledig' }); return; }
    const sleutel = `${o['Athlete ID']}|${o.Category}`;
    if (gezien.has(sleutel)) { fouten.push({ rij: regel, fout: 'dubbel' }); return; }
    gezien.add(sleutel);
    const geboren = datum(o['Date Of Birth Complete']);
    if (!geboren) fouten.push({ rij: regel, fout: 'geboortedatum' });
    rijen.push({
      sportdata_id: o['Athlete ID'],
      voornaam: o['First Name'] || null,
      achternaam: o['Last Name'],
      geslacht: geslachtVan(o.Genus),
      geboortedatum: geboren,
      nationaliteit: (o.Nationality || '').toUpperCase() || null,
      email: email(o.Email),
      nationaal_id: o['National Athlete ID'] || null,
      internationaal_id: o['International-ID'] || null,
      club_sportdata_id: o['Club ID'] || null,
      club_naam: o.Clubname || null,
      club_afkorting: o['Club Abbr'] || null,
      club_land: o['Club Country-Code'] || null,
      categorie: o.Category,
      onderdeel: onderdeelVan(o.Category),
      // Sportdata: lage band is de gup, hoge band de dan; 0 is geen.
      gup: getal(o['Lower-Belt-Grade']),
      dan: getal(o['Higher-Belt-Grade']),
      lengte_cm: getal(o['Size cm']),
      gewicht_kg: getal(o['Weight kg']),
      sportdata_regtime: tijd(o.RegTime),
    });
  });
  return { rijen, fouten, genegeerd, weggelaten, kopOntbreekt: false };
}
